// extracted by mini-css-extract-plugin
export default {"wrapper":"tableTop_wrapper__PGqTB"};